import { provide as M, readonly as w, inject as L, watch as I, normalizeClass as re, camelize as j, reactive as ee, toRef as le, toRaw as ce, computed as O, defineComponent as _, ref as X, getCurrentInstance as g, useAttrs as $, openBlock as S, createElementBlock as oe, normalizeStyle as ie, unref as y, renderSlot as v, createCommentVNode as b, toRefs as ge, onUnmounted as ne, useSlots as G, markRaw as Ne, onUpdated as Ee, Fragment as We, createBlock as V, Teleport as Ke, mergeProps as z, withCtx as A, createElementVNode as Be, isRef as pe, createVNode as ue, createSlots as de } from "vue";
import { useLeafletEvent as De, useLeafletMap as Fe, useLeafletReady as P, useLeafletControlPosition as ke, useLeafletPane as Ge, useLeafletTileLayer as He, useLeafletDisplayLayer as be, useLeafletMarker as je, useLeafletDeps as Xe, useLeafletIcon as Je, useLeafletDefaultIcon as qe, useLeafletDivIcon as Qe, useLeafletLayersControl as Ye, useLeafletDisplayControl as q, useLeafletZoomControl as eo, useLeafletScaleControl as oo, useLeafletAttributionControl as to, useLeafletLocateControl as no } from "vue-use-leaflet";
import { toRef as W, usePreferredDark as ao, useVModel as K, syncRef as so } from "@vueuse/core";
import { isDefined as D, toValue as J, syncRef as ro, toRef as lo } from "@vueuse/shared";
import { v4 as io } from "uuid";
const Se = Symbol(
  ""
), Ce = Symbol(
  ""
);
function co(e) {
  M(Se, w(e));
}
function U(e = !0) {
  const s = L(Se, void 0);
  if (e && s === void 0)
    throw new Error("The top component does not provide a map instance.");
  return s;
}
function po(e) {
  M(Ce, w(e));
}
function To() {
  return L(Ce, void 0);
}
function ze(e) {
  return e && e[0].toUpperCase() + e.slice(1);
}
function te(e) {
  return e && e[0].toLowerCase() + e.slice(1);
}
function uo(e) {
  return !(e != null && e.length);
}
function fe(e, s, n, t) {
  return De(e, s, (a) => {
    const r = `on${ze(a.type)}`;
    n[r] ? typeof n[r] == "function" ? n[r](a) : Array.isArray(n[r]) && n[r].forEach((p) => {
      typeof p == "function" && p(a);
    }) : t == null || t(a.type, a);
  });
}
function F(e, s) {
  const n = W(e), t = W(s), a = [];
  a.push(
    I(t, (i, f) => {
      n.value && r(n.value, i, f);
    })
  ), a.push(
    I(
      n,
      () => {
        n.value && r(n.value, t.value);
      },
      { immediate: !0 }
    )
  );
  function r(i, f, u) {
    p(i, u), o(i, f);
  }
  function p(i, f) {
    const u = l(f);
    i.classList.remove(...u);
  }
  function o(i, f) {
    const u = l(f);
    i.classList.add(...u);
  }
  function l(i) {
    return re(i).split(" ").filter((f) => !!f);
  }
  return () => {
    a.forEach((i) => i()), a.length = 0;
  };
}
const Q = "on", me = Q.length + 1;
function fo(e, s) {
  const n = `${Q}${ze(j(s))}`, { props: t } = e.vnode;
  return !!(t && n in t);
}
function k(e, s, n, t = [], a = !1, r = !1) {
  const p = {}, o = a ? ee({}) : {}, l = [], i = new Set(n), f = new Set(t.map(j));
  if (!r)
    for (let d = 0; d < n.length; d++) {
      const c = n[d];
      p[c] = le(s, c);
    }
  const u = e.vnode.props;
  if (u)
    for (const d in u)
      if (d.startsWith(Q) && d[me]) {
        const c = te(d.slice(2));
        !uo(c) && !f.has(c) && l.push(c);
      } else {
        const c = te(j(d));
        !i.has(c) && c in s && (o[c] = a ? le(s, c) : ce(s[c]));
      }
  return { refs: p, rest: o, events: l };
}
function T(e, s = {}) {
  const { camelizeKeys: n = !0, rawValue: t = !0 } = s, a = {};
  for (const r in e)
    r.startsWith(Q) && r[me] || (a[n ? j(r) : r] = t ? ce(e[r]) : e[r]);
  return a;
}
function ye(e, s, n, t = [], a = !1, r = !1, p = []) {
  const o = {
    matching: a ? ee({}) : {},
    rest: a ? ee({}) : {}
  }, l = new Set(t), i = new Set(p), f = n.length, u = e.vnode.props;
  if (u) {
    for (const d in u)
      if (!(d.startsWith(Q) && d[me])) {
        let c = te(j(d));
        if (!l.has(c) && c in s) {
          const m = a ? le(s, c) : ce(s[c]);
          c.startsWith(n) && c[f] ? (r && !i.has(c) && (c = te(c.slice(f))), o.matching[c] = m) : o.rest[c] = m;
        }
      }
  }
  return o;
}
function mo(e, s = {}) {
  const { cssPrefix: n = "v-map-theme--" } = s, t = W(e), a = W(n), r = ao();
  return O(() => `${a.value}${!t.value || t.value === "auto" ? r.value ? "dark" : "light" : t.value}`);
}
const yo = ["id"], Oo = /* @__PURE__ */ _({
  inheritAttrs: !1,
  __name: "VMap",
  props: {
    center: { default: () => [0, 0] },
    zoom: { default: 0 },
    bounds: { default: void 0 },
    useFly: { type: Boolean, default: !1 },
    theme: { default: "light" },
    id: { default: void 0 },
    class: { default: void 0 },
    style: { default: void 0 },
    preferCanvas: { type: Boolean },
    attributionControl: { type: Boolean, default: !1 },
    zoomControl: { type: Boolean, default: !1 },
    closePopupOnClick: { type: Boolean },
    zoomSnap: {},
    zoomDelta: {},
    trackResize: { type: Boolean },
    boxZoom: { type: Boolean },
    doubleClickZoom: { type: [Boolean, String] },
    dragging: { type: Boolean },
    crs: {},
    minZoom: {},
    maxZoom: {},
    layers: {},
    maxBounds: {},
    renderer: {},
    fadeAnimation: { type: Boolean },
    markerZoomAnimation: { type: Boolean },
    transform3DLimit: {},
    zoomAnimation: { type: Boolean },
    zoomAnimationThreshold: {},
    inertia: { type: Boolean },
    inertiaDeceleration: {},
    inertiaMaxSpeed: {},
    easeLinearity: {},
    worldCopyJump: { type: Boolean },
    maxBoundsViscosity: {},
    keyboard: { type: Boolean },
    keyboardPanDelta: {},
    scrollWheelZoom: { type: [Boolean, String] },
    wheelDebounceTime: {},
    wheelPxPerZoomLevel: {},
    tap: { type: Boolean },
    tapTolerance: {},
    touchZoom: { type: [Boolean, String] },
    bounceAtZoomLimits: { type: Boolean }
  },
  emits: ["viewChanged", "baselayerchange", "overlayadd", "overlayremove", "layeradd", "layerremove", "zoomlevelschange", "resize", "unload", "viewreset", "load", "zoomstart", "movestart", "zoom", "move", "zoomend", "moveend", "popupopen", "popupclose", "autopanstart", "tooltipopen", "tooltipclose", "locationerror", "locationfound", "click", "dblclick", "mousedown", "mouseup", "mouseover", "mouseout", "mousemove", "contextmenu", "keypress", "keydown", "keyup", "preclick", "zoomanim"],
  setup(e, { expose: s, emit: n }) {
    const t = e, a = X(null), r = g(), {
      refs: {
        center: p,
        zoom: o,
        bounds: l,
        useFly: i,
        theme: f,
        class: u,
        zoomControl: d,
        attributionControl: c
      },
      rest: m,
      events: h
    } = k(
      r,
      t,
      [
        "center",
        "zoom",
        "bounds",
        "useFly",
        "id",
        "theme",
        "class",
        "style",
        "zoomControl",
        "attributionControl"
      ],
      ["view-changed"]
    ), C = $(), Z = fo(r, "view-changed"), x = Fe(a, {
      center: p,
      zoom: o,
      bounds: l,
      useFly: i,
      zoomControl: d.value,
      attributionControl: c.value,
      onViewChanged: Z ? (B) => n("viewChanged", B) : void 0,
      ...m,
      ...T(C)
    }), N = mo(f), E = P(x);
    return fe(x, h, C, n), F(a, u), F(a, N), ke(x, [
      ["center", "left"],
      ["center", "right"],
      ["htop", "left"],
      ["htop", "right"],
      ["htop", "center"],
      ["hbottom", "left"],
      ["hbottom", "right"],
      ["hbottom", "center"]
    ]), co(x), s({
      container: a,
      map: x
    }), (B, Y) => (S(), oe("div", {
      ref_key: "container",
      ref: a,
      class: "v-map",
      id: B.id,
      style: ie(B.style)
    }, [
      y(E) ? v(B.$slots, "default", { key: 0 }) : b("", !0)
    ], 12, yo));
  }
});
const Uo = /* @__PURE__ */ _({
  inheritAttrs: !1,
  __name: "VMapPane",
  props: {
    name: {},
    zIndex: {},
    class: {}
  },
  setup(e, { expose: s }) {
    const n = e, { name: t, zIndex: a, class: r } = ge(n), p = U(), { paneElements: o } = Ge(p, t, { zIndex: a == null ? void 0 : a.value }), l = O(
      () => o.value[t.value] ?? null
    ), i = P(l);
    return F(l, r), I(
      () => a == null ? void 0 : a.value,
      (f) => {
        if (D(l)) {
          const u = D(f) ? `${f}` : "auto";
          l.value.style.zIndex = u;
        }
      }
    ), po(l), s({
      paneElement: l
    }), (f, u) => y(i) ? v(f.$slots, "default", { key: 0 }) : b("", !0);
  }
}), Ae = Symbol(
  ""
), Re = Symbol(
  ""
), Me = Symbol(
  ""
), we = Symbol(
  ""
), ae = Symbol(
  ""
);
function vo(e) {
  M(Ae, w(e));
}
function Zo() {
  return L(Ae, void 0);
}
function ho(e) {
  M(Re, w(e));
}
function No() {
  return L(Re, void 0);
}
function Le(e) {
  M(Me, w(e));
}
function Eo() {
  return L(Me, void 0);
}
function _o(e) {
  M(we, w(e));
}
function Wo() {
  return L(we, void 0);
}
function Pe(e, s) {
  M(e, s);
}
function se(e) {
  return L(e, void 0);
}
const xe = Symbol(
  ""
), Ie = Symbol(
  ""
), $e = Symbol(
  ""
), Ve = Symbol(
  ""
), Te = Symbol(
  ""
), Oe = Symbol(
  ""
), Ue = Symbol(
  ""
), H = /* @__PURE__ */ _({
  inheritAttrs: !1,
  __name: "VMapTileLayer",
  props: {
    url: {},
    title: { default: void 0 },
    overlay: { type: Boolean, default: !1 },
    id: {},
    accessToken: {},
    minZoom: {},
    maxZoom: {},
    maxNativeZoom: {},
    minNativeZoom: {},
    subdomains: {},
    errorTileUrl: {},
    zoomOffset: {},
    tms: { type: Boolean },
    zoomReverse: { type: Boolean },
    detectRetina: { type: Boolean },
    crossOrigin: { type: [String, Boolean] },
    referrerPolicy: { type: [String, Boolean] },
    tileSize: {},
    opacity: {},
    updateWhenIdle: { type: Boolean },
    updateWhenZooming: { type: Boolean },
    updateInterval: {},
    zIndex: {},
    bounds: {},
    noWrap: { type: Boolean },
    pane: {},
    className: {},
    keepBuffer: {},
    attribution: {}
  },
  emits: ["tileabort", "loading", "tileunload", "tileloadstart", "tileerror", "tileload", "load", "add", "remove", "popupopen", "popupclose", "tooltipopen", "tooltipclose"],
  setup(e, { expose: s, emit: n }) {
    const t = e, a = g(), {
      refs: { url: r, title: p, overlay: o },
      rest: l,
      events: i
    } = k(a, t, ["url", "title", "overlay"]), f = $(), u = He(r, Object.assign(l, T(f))), d = P(u), c = se(Te);
    if (fe(u, i, f, n), c) {
      const m = io();
      c.add(m, y(p), u, y(o)), I(p, (h) => {
        c.updateName(m, h);
      }), I(o, (h) => {
        c.updateOverlay(m, h);
      }), ne(() => {
        c.remove(m);
      });
    } else {
      const m = U();
      be(m, u);
    }
    return vo(u), s({
      tileLayer: u
    }), (m, h) => y(d) ? v(m.$slots, "default", { key: 0 }) : b("", !0);
  }
});
function go(e) {
  function s(n) {
    e.icon.value = n;
  }
  return {
    setIcon: s
  };
}
const ve = /* @__PURE__ */ _({
  inheritAttrs: !1,
  __name: "VMapMarker",
  props: {
    latlng: {},
    icon: {},
    opacity: {},
    zIndexOffset: {},
    draggable: { type: Boolean },
    keyboard: { type: Boolean },
    title: {},
    alt: {},
    riseOnHover: { type: Boolean },
    riseOffset: {},
    shadowPane: {},
    autoPan: { type: Boolean },
    autoPanPadding: {},
    autoPanSpeed: {},
    autoPanOnFocus: { type: Boolean },
    interactive: { type: Boolean },
    bubblingMouseEvents: { type: Boolean },
    pane: {},
    attribution: {}
  },
  emits: ["update:latlng", "move", "dragstart", "movestart", "drag", "dragend", "moveend", "click", "dblclick", "mousedown", "mouseup", "mouseover", "mouseout", "contextmenu", "add", "remove", "popupopen", "popupclose", "tooltipopen", "tooltipclose"],
  setup(e, { expose: s, emit: n }) {
    const t = e, a = g(), {
      refs: { icon: r, opacity: p, zIndexOffset: o, draggable: l },
      rest: i,
      events: f
    } = k(
      a,
      t,
      ["latlng", "icon", "opacity", "zIndexOffset", "draggable"],
      ["update:latlng"]
    ), u = $(), d = G(), c = K(t, "latlng", n), m = W(null);
    so(W(r), m, { immediate: !0, direction: "ltr" });
    const h = je(c, {
      icon: m,
      opacity: p,
      zIndexOffset: o,
      draggable: l,
      ...i,
      ...T(u)
    }), C = U(), Z = P(h), x = go({ icon: m }), N = d.default ? Xe(h, m) : h;
    return be(C, N), fe(h, f, u, n), ho(h), Pe(ae, x), s({
      marker: h
    }), (E, B) => y(Z) ? v(E.$slots, "default", { key: 0 }) : b("", !0);
  }
});
function he(e, s) {
  return O(() => {
    const n = J(e), t = J(s);
    if (!(n == null && t == null))
      return `${re(n)} ${re(t)}`.trim();
  });
}
const Bo = /* @__PURE__ */ _({
  inheritAttrs: !1,
  __name: "VMapIcon",
  props: {
    iconUrl: {},
    iconRetinaUrl: {},
    iconSize: {},
    iconAnchor: {},
    shadowUrl: {},
    shadowRetinaUrl: {},
    shadowSize: {},
    shadowAnchor: {},
    knownClasses: {},
    class: {},
    className: {},
    crossOrigin: { type: [String, Boolean] },
    popupAnchor: {},
    tooltipAnchor: {},
    pane: {},
    attribution: {}
  },
  setup(e, { expose: s }) {
    const n = e, t = g(), {
      refs: { iconUrl: a, class: r, className: p, ...o },
      rest: l
    } = k(t, n, [
      "iconUrl",
      "iconRetinaUrl",
      "iconSize",
      "iconAnchor",
      "shadowUrl",
      "shadowRetinaUrl",
      "shadowSize",
      "shadowAnchor",
      "knownClasses",
      "class",
      "className"
    ]), i = $(), f = he(r, p), u = Je(a, {
      className: f,
      ...o,
      ...l,
      ...T(i)
    }), d = P(u), c = se(ae);
    return c && (I(
      u,
      (m) => {
        c.setIcon(m);
      },
      { immediate: !0 }
    ), ne(() => {
      c.setIcon(null);
    })), Le(u), s({
      icon: u
    }), (m, h) => y(d) ? v(m.$slots, "default", { key: 0 }) : b("", !0);
  }
}), Ko = /* @__PURE__ */ _({
  inheritAttrs: !1,
  __name: "VMapDefaultIcon",
  props: {
    iconUrl: {},
    imagePath: {},
    knownClasses: {},
    class: {},
    className: {},
    crossOrigin: { type: [String, Boolean] },
    iconRetinaUrl: {},
    iconSize: {},
    iconAnchor: {},
    popupAnchor: {},
    tooltipAnchor: {},
    shadowUrl: {},
    shadowRetinaUrl: {},
    shadowSize: {},
    shadowAnchor: {},
    pane: {},
    attribution: {}
  },
  setup(e, { expose: s }) {
    const n = e, t = g(), {
      refs: { iconUrl: a, imagePath: r, class: p, className: o, knownClasses: l, ...i },
      rest: f
    } = k(t, n, [
      "iconUrl",
      "imagePath",
      "iconRetinaUrl",
      "iconSize",
      "iconAnchor",
      "shadowUrl",
      "shadowRetinaUrl",
      "shadowSize",
      "shadowAnchor",
      "knownClasses",
      "class",
      "className"
    ]), u = $(), d = he(p, o), c = qe({
      iconUrl: a,
      imagePath: r == null ? void 0 : r.value,
      className: d,
      knownClasses: l,
      ...i,
      ...f,
      ...T(u)
    }), m = P(c), h = se(ae);
    return h && (I(
      c,
      (C) => {
        h.setIcon(C);
      },
      { immediate: !0 }
    ), ne(() => {
      h.setIcon(null);
    })), Le(c), s({
      icon: c
    }), (C, Z) => y(m) ? v(C.$slots, "default", { key: 0 }) : b("", !0);
  }
}), Ze = /* @__PURE__ */ _({
  inheritAttrs: !1,
  __name: "VMapDivIcon",
  props: {
    html: { type: [String, Boolean] },
    bgPos: {},
    iconSize: {},
    iconAnchor: {},
    renderMode: {},
    rootClass: {},
    knownClasses: {},
    class: {},
    className: {},
    popupAnchor: {},
    iconUrl: {},
    iconRetinaUrl: {},
    tooltipAnchor: {},
    shadowUrl: {},
    shadowRetinaUrl: {},
    shadowSize: {},
    shadowAnchor: {},
    pane: {},
    attribution: {}
  },
  setup(e, { expose: s }) {
    const n = e, t = g(), {
      refs: { html: a, class: r, className: p, renderMode: o, rootClass: l, ...i },
      rest: f
    } = k(t, n, [
      "html",
      "bgPos",
      "iconSize",
      "iconAnchor",
      "renderMode",
      "rootClass",
      "knownClasses",
      "class",
      "className"
    ]), u = $(), d = G(), c = X(null);
    ro(lo(a), c, { immediate: !0, direction: "ltr" });
    const m = X(null), h = he(r, p), C = Qe(c, {
      className: h,
      ...i,
      ...f,
      ...T(u)
    }), Z = P(C), x = se(ae);
    x && (I(
      C,
      (B) => {
        x.setIcon(B);
      },
      { immediate: !0 }
    ), ne(() => {
      x.setIcon(null);
    })), d.default && (o == null ? void 0 : o.value) === "portal" && (m.value = Ne(document.createElement("div")), c.value = m.value, F(m, l)), d.default && (o == null ? void 0 : o.value) === "node" && (I(
      m,
      () => {
        N(m), c.value = m.value;
      },
      { flush: "sync" }
    ), F(m, l)), d.default && (!(o != null && o.value) || o.value === "html") && (I(
      m,
      () => {
        N(m), E(m);
      },
      { flush: "sync" }
    ), Ee(() => {
      E(m);
    }));
    function N(B) {
      var Y;
      if (D(B)) {
        const _e = J(B);
        (Y = _e.parentNode) == null || Y.removeChild(_e);
      }
    }
    function E(B) {
      D(B) && (c.value = J(B).innerHTML);
    }
    return _o(C), s({
      icon: C
    }), (B, Y) => y(d).default ? (S(), oe(We, { key: 0 }, [
      y(o) === "portal" ? (S(), V(Ke, {
        key: 0,
        to: m.value
      }, [
        y(Z) ? v(B.$slots, "default", { key: 0 }) : b("", !0)
      ], 8, ["to"])) : y(o) !== "none" ? (S(), oe("div", {
        key: 1,
        ref_key: "rootEl",
        ref: m
      }, [
        y(Z) ? v(B.$slots, "default", { key: 0 }) : b("", !0)
      ], 512)) : y(Z) ? v(B.$slots, "default", { key: 2 }) : b("", !0)
    ], 64)) : b("", !0);
  }
});
function R(e) {
  const s = X(null), n = O(
    () => D(s) ? e(s.value) : null
  );
  return { templateRef: s, value: n };
}
const ko = /* @__PURE__ */ Be("div", { class: "v-map-pin-icon__shadow" }, null, -1), bo = /* @__PURE__ */ _({
  __name: "VMapPinIcon",
  props: {
    color: { default: void 0 },
    backgroundColor: { default: void 0 },
    placeholderColor: { default: void 0 },
    html: { type: [String, Boolean], default: void 0 },
    bgPos: { default: void 0 },
    iconSize: { default: () => [32, 46] },
    iconAnchor: { default: () => [16, 46] },
    renderMode: { default: void 0 },
    rootClass: { default: void 0 },
    knownClasses: { default: void 0 },
    class: { default: void 0 },
    className: { default: void 0 },
    popupAnchor: { default: () => [0, -50] },
    iconUrl: {},
    iconRetinaUrl: {},
    tooltipAnchor: {},
    shadowUrl: {},
    shadowRetinaUrl: {},
    shadowSize: {},
    shadowAnchor: {},
    pane: {},
    attribution: {}
  },
  setup(e, { expose: s }) {
    const n = e, t = g(), {
      refs: { color: a, backgroundColor: r, placeholderColor: p },
      rest: o
    } = k(
      t,
      n,
      [
        "color",
        "backgroundColor",
        "placeholderColor",
        "iconSize",
        "iconAnchor",
        "popupAnchor"
      ],
      [],
      !0
    ), l = G(), i = X([0, -50]), f = O(() => ({
      color: r.value ?? a.value
    })), u = O(() => ({
      color: a.value,
      backgroundColor: p.value
    })), { templateRef: d, value: c } = R((m) => m.icon);
    return s({
      icon: c
    }), (m, h) => (S(), V(Ze, z({
      ref_key: "templateRef",
      ref: d,
      class: "v-map-pin-icon",
      "icon-size": m.iconSize,
      "icon-anchor": m.iconAnchor,
      "popup-anchor": i.value
    }, y(o)), {
      default: A(() => [
        ko,
        Be("div", {
          class: "v-map-pin-icon__pin",
          style: ie(f.value)
        }, null, 4),
        y(l).default ? (S(), oe("div", {
          key: 0,
          class: "v-map-pin-icon__icon",
          style: ie(u.value)
        }, [
          v(m.$slots, "default")
        ], 4)) : b("", !0)
      ]),
      _: 3
    }, 16, ["icon-size", "icon-anchor", "popup-anchor"]));
  }
});
const Do = /* @__PURE__ */ _({
  __name: "VMapPinMarker",
  props: {
    latlng: {},
    iconColor: {},
    iconBackgroundColor: {},
    iconPlaceholderColor: {},
    iconHtml: { type: [String, Boolean] },
    iconBgPos: {},
    iconRenderMode: {},
    iconRootClass: {},
    iconUrl: {},
    iconRetinaUrl: {},
    iconSize: {},
    iconAnchor: {},
    iconShadowUrl: {},
    iconShadowRetinaUrl: {},
    iconShadowSize: {},
    iconShadowAnchor: {},
    iconKnownClasses: {},
    iconClass: {},
    iconClassName: {},
    iconCrossOrigin: { type: [String, Boolean] },
    iconPopupAnchor: {},
    iconTooltipAnchor: {},
    iconPane: {},
    iconAttribution: {},
    icon: {},
    draggable: { type: Boolean },
    keyboard: { type: Boolean },
    title: {},
    alt: {},
    zIndexOffset: {},
    opacity: {},
    riseOnHover: { type: Boolean },
    riseOffset: {},
    shadowPane: {},
    autoPan: { type: Boolean },
    autoPanPadding: {},
    autoPanSpeed: {},
    autoPanOnFocus: { type: Boolean },
    interactive: { type: Boolean },
    bubblingMouseEvents: { type: Boolean },
    pane: {},
    attribution: {}
  },
  emits: ["update:latlng"],
  setup(e, { expose: s, emit: n }) {
    const t = e, a = g(), r = ye(a, t, "icon", ["latlng"], !0, !0, [
      "iconRetinaUrl",
      "iconSize",
      "iconAnchor"
    ]), p = G(), o = K(t, "latlng", n), { templateRef: l, value: i } = R((d) => d.marker), { templateRef: f, value: u } = R((d) => d.icon);
    return s({
      marker: i,
      icon: u
    }), (d, c) => (S(), V(ve, z({
      ref_key: "markerRef",
      ref: l,
      latlng: y(o),
      "onUpdate:latlng": c[0] || (c[0] = (m) => pe(o) ? o.value = m : null)
    }, y(r).rest), {
      default: A(() => [
        ue(bo, z({
          ref_key: "iconRef",
          ref: f
        }, y(r).matching), de({ _: 2 }, [
          y(p).default ? {
            name: "default",
            fn: A(() => [
              v(d.$slots, "default")
            ]),
            key: "0"
          } : void 0
        ]), 1040)
      ]),
      _: 3
    }, 16, ["latlng"]));
  }
}), Fo = /* @__PURE__ */ _({
  __name: "VMapDivMarker",
  props: {
    latlng: {},
    iconHtml: { type: [String, Boolean] },
    iconBgPos: {},
    iconRenderMode: {},
    iconRootClass: {},
    iconUrl: {},
    iconRetinaUrl: {},
    iconSize: {},
    iconAnchor: {},
    iconShadowUrl: {},
    iconShadowRetinaUrl: {},
    iconShadowSize: {},
    iconShadowAnchor: {},
    iconKnownClasses: {},
    iconClass: {},
    iconClassName: {},
    iconCrossOrigin: { type: [String, Boolean] },
    iconPopupAnchor: {},
    iconTooltipAnchor: {},
    iconPane: {},
    iconAttribution: {},
    icon: {},
    draggable: { type: Boolean },
    keyboard: { type: Boolean },
    title: {},
    alt: {},
    zIndexOffset: {},
    opacity: {},
    riseOnHover: { type: Boolean },
    riseOffset: {},
    shadowPane: {},
    autoPan: { type: Boolean },
    autoPanPadding: {},
    autoPanSpeed: {},
    autoPanOnFocus: { type: Boolean },
    interactive: { type: Boolean },
    bubblingMouseEvents: { type: Boolean },
    pane: {},
    attribution: {}
  },
  emits: ["update:latlng"],
  setup(e, { expose: s, emit: n }) {
    const t = e, a = g(), r = ye(a, t, "icon", ["latlng"], !0, !0, [
      "iconRetinaUrl",
      "iconSize",
      "iconAnchor"
    ]), p = G(), o = K(t, "latlng", n), { templateRef: l, value: i } = R((d) => d.marker), { templateRef: f, value: u } = R((d) => d.icon);
    return s({
      marker: i,
      icon: u
    }), (d, c) => (S(), V(ve, z({
      ref_key: "markerRef",
      ref: l,
      latlng: y(o),
      "onUpdate:latlng": c[0] || (c[0] = (m) => pe(o) ? o.value = m : null)
    }, y(r).rest), {
      default: A(() => [
        ue(Ze, z({
          ref_key: "iconRef",
          ref: f
        }, y(r).matching), de({ _: 2 }, [
          y(p).default ? {
            name: "default",
            fn: A(() => [
              v(d.$slots, "default")
            ]),
            key: "0"
          } : void 0
        ]), 1040)
      ]),
      _: 3
    }, 16, ["latlng"]));
  }
}), Go = /* @__PURE__ */ _({
  __name: "VMapIconMarker",
  props: {
    latlng: {},
    iconUrl: {},
    iconRetinaUrl: {},
    iconSize: {},
    iconAnchor: {},
    iconShadowUrl: {},
    iconShadowRetinaUrl: {},
    iconShadowSize: {},
    iconShadowAnchor: {},
    iconKnownClasses: {},
    iconClass: {},
    iconClassName: {},
    iconCrossOrigin: { type: [String, Boolean] },
    iconPopupAnchor: {},
    iconTooltipAnchor: {},
    iconPane: {},
    iconAttribution: {},
    icon: {},
    draggable: { type: Boolean },
    keyboard: { type: Boolean },
    title: {},
    alt: {},
    zIndexOffset: {},
    opacity: {},
    riseOnHover: { type: Boolean },
    riseOffset: {},
    shadowPane: {},
    autoPan: { type: Boolean },
    autoPanPadding: {},
    autoPanSpeed: {},
    autoPanOnFocus: { type: Boolean },
    interactive: { type: Boolean },
    bubblingMouseEvents: { type: Boolean },
    pane: {},
    attribution: {}
  },
  emits: ["update:latlng"],
  setup(e, { expose: s, emit: n }) {
    const t = e, a = g(), r = ye(
      a,
      t,
      "icon",
      ["latlng", "iconUrl"],
      !0,
      !0,
      ["iconRetinaUrl", "iconSize", "iconAnchor"]
    ), p = G(), o = K(t, "latlng", n), { templateRef: l, value: i } = R((d) => d.marker), { templateRef: f, value: u } = R((d) => d.icon);
    return s({
      marker: i,
      icon: u
    }), (d, c) => (S(), V(ve, z({
      ref_key: "markerRef",
      ref: l,
      latlng: y(o),
      "onUpdate:latlng": c[0] || (c[0] = (m) => pe(o) ? o.value = m : null)
    }, y(r).rest), {
      default: A(() => [
        ue(Bo, z({
          ref_key: "iconRef",
          ref: f,
          "icon-url": d.iconUrl
        }, y(r).matching), de({ _: 2 }, [
          y(p).default ? {
            name: "default",
            fn: A(() => [
              v(d.$slots, "default")
            ]),
            key: "0"
          } : void 0
        ]), 1040, ["icon-url"])
      ]),
      _: 3
    }, 16, ["latlng"]));
  }
}), Ho = /* @__PURE__ */ _({
  __name: "VMapOsmTileLayer",
  props: {
    title: { default: "Open Street Map" },
    overlay: { type: Boolean },
    id: {},
    accessToken: {},
    minZoom: {},
    maxZoom: {},
    maxNativeZoom: {},
    minNativeZoom: {},
    subdomains: {},
    errorTileUrl: {},
    zoomOffset: {},
    tms: { type: Boolean },
    zoomReverse: { type: Boolean },
    detectRetina: { type: Boolean },
    crossOrigin: { type: [String, Boolean] },
    referrerPolicy: { type: [String, Boolean] },
    tileSize: {},
    opacity: {},
    updateWhenIdle: { type: Boolean },
    updateWhenZooming: { type: Boolean },
    updateInterval: {},
    zIndex: {},
    bounds: {},
    noWrap: { type: Boolean },
    pane: {},
    className: {},
    keepBuffer: {},
    attribution: {}
  },
  setup(e, { expose: s }) {
    const n = e, t = g(), { rest: a } = k(
      t,
      n,
      ["title", "overlay"],
      [],
      !0,
      !0
    ), { templateRef: r, value: p } = R((o) => o.tileLayer);
    return s({
      tileLayer: p
    }), (o, l) => (S(), V(H, z({
      ref_key: "templateRef",
      ref: r,
      url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      title: o.title,
      overlay: o.overlay
    }, y(a)), {
      default: A(() => [
        v(o.$slots, "default")
      ]),
      _: 3
    }, 16, ["title", "overlay"]));
  }
}), jo = /* @__PURE__ */ _({
  __name: "VMapMapboxTileLayer",
  props: {
    id: {},
    accessToken: {},
    title: { default: "Mapbox" },
    overlay: { type: Boolean },
    minZoom: {},
    maxZoom: {},
    maxNativeZoom: {},
    minNativeZoom: {},
    subdomains: {},
    errorTileUrl: {},
    zoomOffset: {},
    tms: { type: Boolean },
    zoomReverse: { type: Boolean },
    detectRetina: { type: Boolean },
    crossOrigin: { type: [String, Boolean] },
    referrerPolicy: { type: [String, Boolean] },
    tileSize: {},
    opacity: {},
    updateWhenIdle: { type: Boolean },
    updateWhenZooming: { type: Boolean },
    updateInterval: {},
    zIndex: {},
    bounds: {},
    noWrap: { type: Boolean },
    pane: {},
    className: {},
    keepBuffer: {},
    attribution: {}
  },
  setup(e, { expose: s }) {
    const n = e, t = g(), { rest: a } = k(
      t,
      n,
      ["id", "accessToken", "title", "overlay"],
      [],
      !0,
      !0
    ), { templateRef: r, value: p } = R((o) => o.tileLayer);
    return s({
      tileLayer: p
    }), (o, l) => (S(), V(H, z({
      ref_key: "templateRef",
      ref: r,
      url: "https://api.mapbox.com/styles/v1/mapbox/{id}/tiles/{z}/{x}/{y}?access_token={accessToken}",
      id: o.id,
      "access-token": o.accessToken,
      title: o.title,
      overlay: o.overlay
    }, y(a)), {
      default: A(() => [
        v(o.$slots, "default")
      ]),
      _: 3
    }, 16, ["id", "access-token", "title", "overlay"]));
  }
}), Xo = /* @__PURE__ */ _({
  __name: "VMapArcGisAeroTileLayer",
  props: {
    title: { default: "Arc Gis Aero" },
    overlay: { type: Boolean },
    id: {},
    accessToken: {},
    minZoom: {},
    maxZoom: {},
    maxNativeZoom: {},
    minNativeZoom: {},
    subdomains: {},
    errorTileUrl: {},
    zoomOffset: {},
    tms: { type: Boolean },
    zoomReverse: { type: Boolean },
    detectRetina: { type: Boolean },
    crossOrigin: { type: [String, Boolean] },
    referrerPolicy: { type: [String, Boolean] },
    tileSize: {},
    opacity: {},
    updateWhenIdle: { type: Boolean },
    updateWhenZooming: { type: Boolean },
    updateInterval: {},
    zIndex: {},
    bounds: {},
    noWrap: { type: Boolean },
    pane: {},
    className: {},
    keepBuffer: {},
    attribution: {}
  },
  setup(e, { expose: s }) {
    const n = e, t = g(), { rest: a } = k(
      t,
      n,
      ["title", "overlay"],
      [],
      !0,
      !0
    ), { templateRef: r, value: p } = R((o) => o.tileLayer);
    return s({
      tileLayer: p
    }), (o, l) => (S(), V(H, z({
      ref_key: "templateRef",
      ref: r,
      url: "https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}",
      title: o.title,
      overlay: o.overlay
    }, y(a)), {
      default: A(() => [
        v(o.$slots, "default")
      ]),
      _: 3
    }, 16, ["title", "overlay"]));
  }
}), Jo = /* @__PURE__ */ _({
  __name: "VMapArcGisTileLayer",
  props: {
    title: { default: "Arc Gis" },
    overlay: { type: Boolean },
    id: {},
    accessToken: {},
    minZoom: {},
    maxZoom: {},
    maxNativeZoom: {},
    minNativeZoom: {},
    subdomains: {},
    errorTileUrl: {},
    zoomOffset: {},
    tms: { type: Boolean },
    zoomReverse: { type: Boolean },
    detectRetina: { type: Boolean },
    crossOrigin: { type: [String, Boolean] },
    referrerPolicy: { type: [String, Boolean] },
    tileSize: {},
    opacity: {},
    updateWhenIdle: { type: Boolean },
    updateWhenZooming: { type: Boolean },
    updateInterval: {},
    zIndex: {},
    bounds: {},
    noWrap: { type: Boolean },
    pane: {},
    className: {},
    keepBuffer: {},
    attribution: {}
  },
  setup(e, { expose: s }) {
    const n = e, t = g(), { rest: a } = k(
      t,
      n,
      ["title", "overlay"],
      [],
      !0,
      !0
    ), { templateRef: r, value: p } = R((o) => o.tileLayer);
    return s({
      tileLayer: p
    }), (o, l) => (S(), V(H, z({
      ref_key: "templateRef",
      ref: r,
      url: "https://server.arcgisonline.com/ArcGIS/rest/services/World_Street_Map/MapServer/tile/{z}/{y}/{x}",
      title: o.title,
      overlay: o.overlay
    }, y(a)), {
      default: A(() => [
        v(o.$slots, "default")
      ]),
      _: 3
    }, 16, ["title", "overlay"]));
  }
}), qo = /* @__PURE__ */ _({
  __name: "VMapOpenTransportTileLayer",
  props: {
    apiKey: {},
    title: { default: "Open Transport" },
    overlay: { type: Boolean },
    id: {},
    accessToken: {},
    minZoom: {},
    maxZoom: {},
    maxNativeZoom: {},
    minNativeZoom: {},
    subdomains: {},
    errorTileUrl: {},
    zoomOffset: {},
    tms: { type: Boolean },
    zoomReverse: { type: Boolean },
    detectRetina: { type: Boolean },
    crossOrigin: { type: [String, Boolean] },
    referrerPolicy: { type: [String, Boolean] },
    tileSize: {},
    opacity: {},
    updateWhenIdle: { type: Boolean },
    updateWhenZooming: { type: Boolean },
    updateInterval: {},
    zIndex: {},
    bounds: {},
    noWrap: { type: Boolean },
    pane: {},
    className: {},
    keepBuffer: {},
    attribution: {}
  },
  setup(e, { expose: s }) {
    const n = e, t = g(), { rest: a } = k(
      t,
      n,
      ["apiKey", "title", "overlay"],
      [],
      !0,
      !0
    ), { templateRef: r, value: p } = R((o) => o.tileLayer);
    return s({
      tileLayer: p
    }), (o, l) => (S(), V(H, z({
      ref_key: "templateRef",
      ref: r,
      url: "https://{s}.tile.thunderforest.com/transport/{z}/{x}/{y}.png?apikey={apiKey}",
      "api-key": o.apiKey,
      title: o.title,
      overlay: o.overlay
    }, y(a)), {
      default: A(() => [
        v(o.$slots, "default")
      ]),
      _: 3
    }, 16, ["api-key", "title", "overlay"]));
  }
}), Qo = /* @__PURE__ */ _({
  __name: "VMapGoogleTileLayer",
  props: {
    type: { default: "streets" },
    layers: { default: void 0 },
    subdomains: { default: () => ["mt0", "mt1", "mt2", "mt3"] },
    title: { default: "Google" },
    overlay: { type: Boolean },
    id: {},
    accessToken: {},
    minZoom: {},
    maxZoom: {},
    maxNativeZoom: {},
    minNativeZoom: {},
    errorTileUrl: {},
    zoomOffset: {},
    tms: { type: Boolean },
    zoomReverse: { type: Boolean },
    detectRetina: { type: Boolean },
    crossOrigin: { type: [String, Boolean] },
    referrerPolicy: { type: [String, Boolean] },
    tileSize: {},
    opacity: {},
    updateWhenIdle: { type: Boolean },
    updateWhenZooming: { type: Boolean },
    updateInterval: {},
    zIndex: {},
    bounds: {},
    noWrap: { type: Boolean },
    pane: {},
    className: {},
    keepBuffer: {},
    attribution: {}
  },
  setup(e, { expose: s }) {
    const n = e, t = g(), {
      refs: { layers: a, type: r },
      rest: p
    } = k(
      t,
      n,
      ["type", "layers", "subdomains", "title", "overlay"],
      [],
      !0
    ), { templateRef: o, value: l } = R((u) => u.tileLayer), i = Object.freeze({
      hybrid: "s,h",
      satellite: "s",
      streets: "m",
      terrain: "p"
    }), f = O(
      () => D(a) ? y(a) : i[y(r)] ?? null
    );
    return s({
      tileLayer: l
    }), (u, d) => (S(), V(H, z({
      ref_key: "templateRef",
      ref: o,
      url: "https://{s}.google.com/vt/lyrs={lyrs}&x={x}&y={y}&z={z}",
      lyrs: f.value,
      subdomains: u.subdomains,
      title: u.title,
      overlay: u.overlay
    }, y(p)), {
      default: A(() => [
        v(u.$slots, "default")
      ]),
      _: 3
    }, 16, ["lyrs", "subdomains", "title", "overlay"]));
  }
});
function So(e) {
  M(xe, w(e));
}
function Yo() {
  return L(xe, void 0);
}
function Co(e) {
  M(Ie, w(e));
}
function et() {
  return L(Ie, void 0);
}
function zo(e) {
  M($e, w(e));
}
function ot() {
  return L($e, void 0);
}
function Ao(e) {
  M(Ve, w(e));
}
function tt() {
  return L(Ve, void 0);
}
function Ro(e) {
  M(
    Oe,
    w(e)
  );
}
function nt() {
  return L(Oe, void 0);
}
function Mo(e) {
  M(Ue, w(e));
}
function at() {
  return L(Ue, void 0);
}
function wo(e) {
  function s(o, l, i, f) {
    e.push({
      id: o,
      name: l,
      layer: i,
      overlay: f
    });
  }
  function n(o) {
    const l = e.findIndex((i) => i.id === o);
    l > -1 && e.splice(l, 1);
  }
  function t(o) {
    return e.find((l) => l.id === o);
  }
  function a() {
    return w(e);
  }
  function r(o, l) {
    const i = t(o);
    i && (i.name = l);
  }
  function p(o, l) {
    const i = t(o);
    i && (i.overlay = l);
  }
  return {
    add: s,
    remove: n,
    getOne: t,
    getAll: a,
    updateName: r,
    updateOverlay: p
  };
}
const st = /* @__PURE__ */ _({
  inheritAttrs: !1,
  __name: "VMapLayersControl",
  props: {
    currentBaseLayer: { default: 0 },
    currentOverlays: { default: void 0 },
    useIndexes: { type: Boolean, default: !1 },
    collapsed: { type: Boolean },
    autoZIndex: { type: Boolean },
    hideSingleBase: { type: Boolean },
    sortLayers: { type: Boolean },
    sortFunction: { type: Function, default: void 0 },
    position: { default: void 0 }
  },
  emits: ["update:currentBaseLayer", "update:currentOverlays"],
  setup(e, { expose: s, emit: n }) {
    const t = e, a = g(), {
      refs: { useIndexes: r },
      rest: p
    } = k(a, t, [
      "currentBaseLayer",
      "currentOverlays",
      "useIndexes"
    ]), o = ee([]), l = K(t, "currentBaseLayer", n), i = K(t, "currentOverlays", n), f = U(), u = $(), d = Ye(o, {
      currentBaseLayer: l,
      currentOverlays: i,
      indexes: r.value,
      ...p,
      ...T(u)
    }), c = wo(o), m = P(d);
    return q(f, d), So(d), Pe(Te, c), s({
      layersControl: d
    }), (h, C) => y(m) ? v(h.$slots, "default", { key: 0 }) : b("", !0);
  }
}), rt = /* @__PURE__ */ _({
  inheritAttrs: !1,
  __name: "VMapZoomControl",
  props: {
    disabled: { type: Boolean },
    zoomInText: { default: void 0 },
    zoomInTitle: { default: void 0 },
    zoomOutText: { default: void 0 },
    zoomOutTitle: { default: void 0 },
    position: { default: "centerright" }
  },
  setup(e, { expose: s }) {
    const n = e, t = g(), {
      refs: { disabled: a, position: r },
      rest: p
    } = k(t, n, ["disabled", "position"]), o = U(), l = $(), i = eo({
      disabled: a,
      position: r.value,
      ...p,
      ...T(l)
    }), f = P(i);
    return q(o, i), Co(i), s({
      zoomControl: i
    }), (u, d) => y(f) ? v(u.$slots, "default", { key: 0 }) : b("", !0);
  }
});
function Lo(e) {
  return I(
    () => J(e),
    (n) => {
      n && (n._updateScale = (t, a, r) => {
        t.style.width = `${Math.round(n.options.maxWidth * r)}px`;
        const p = `<div class="leaflet-control-scale-line__label">${a}</div>`, o = '<div class="leaflet-control-scale-line__line"></div>', l = '<div class="leaflet-control-scale-line__edge"></div>';
        t.innerHTML = `${p}${o}${l}`;
      });
    },
    { immediate: !0, flush: "sync" }
  );
}
const lt = /* @__PURE__ */ _({
  inheritAttrs: !1,
  __name: "VMapScaleControl",
  props: {
    maxWidth: { default: void 0 },
    metric: { type: Boolean },
    imperial: { type: Boolean, default: !1 },
    updateWhenIdle: { type: Boolean },
    position: { default: "bottomright" }
  },
  setup(e, { expose: s }) {
    const n = e, t = g(), {
      refs: { position: a, imperial: r },
      rest: p
    } = k(t, n, ["position", "imperial"]), o = U(), l = $(), i = oo({
      position: a.value,
      imperial: r.value,
      ...p,
      ...T(l)
    });
    Lo(i);
    const f = P(i);
    return q(o, i), zo(i), s({
      scaleControl: i
    }), (u, d) => y(f) ? v(u.$slots, "default", { key: 0 }) : b("", !0);
  }
});
const it = /* @__PURE__ */ _({
  inheritAttrs: !1,
  __name: "VMapAttributionControl",
  props: {
    attributions: { default: void 0 },
    prefix: { type: [String, Boolean, null], default: void 0 },
    position: { default: "bottomright" }
  },
  setup(e, { expose: s }) {
    const n = e, t = g(), {
      refs: { attributions: a, prefix: r },
      rest: p
    } = k(t, n, ["attributions", "prefix"]), o = U(), l = $(), i = to({
      attributions: a,
      prefix: r,
      ...p,
      ...T(l)
    }), f = P(i);
    return q(o, i), Ao(i), s({
      attributionControl: i
    }), (u, d) => y(f) ? v(u.$slots, "default", { key: 0 }) : b("", !0);
  }
}), ct = /* @__PURE__ */ _({
  inheritAttrs: !1,
  __name: "VMapControlPosition",
  props: {
    position: {},
    class: {}
  },
  setup(e, { expose: s }) {
    const n = e, { position: t, class: a } = ge(n), r = U(), { positionElements: p } = ke(r, t), o = O(
      () => Array.isArray(t == null ? void 0 : t.value) ? `${t.value[0]}${t.value[1]}` : void 0
    ), l = O(
      () => o.value ? p.value[o.value] ?? null : null
    ), i = P(l);
    return F(l, a), Ro(l), s({
      positionElement: l
    }), (f, u) => y(i) ? v(f.$slots, "default", { key: 0 }) : b("", !0);
  }
}), pt = /* @__PURE__ */ _({
  inheritAttrs: !1,
  __name: "VMapLocateControl",
  props: {
    position: { default: "centerright" },
    layer: {},
    setView: { type: [Boolean, String] },
    keepCurrentZoomLevel: { type: Boolean },
    initialZoomLevel: { type: [Number, Boolean] },
    flyTo: { type: Boolean },
    clickBehavior: {},
    returnToPrevBounds: { type: Boolean },
    cacheLocation: { type: Boolean },
    drawCircle: { type: Boolean },
    drawMarker: { type: Boolean },
    showCompass: { type: Boolean },
    markerClass: {},
    compassClass: {},
    circleStyle: {},
    markerStyle: {},
    compassStyle: {},
    followCircleStyle: {},
    followMarkerStyle: {},
    icon: {},
    iconLoading: {},
    iconElementTag: {},
    textElementTag: {},
    circlePadding: {},
    metric: { type: Boolean },
    createButtonCallback: {},
    onLocationError: {},
    onLocationOutsideMapBounds: {},
    showPopup: { type: Boolean },
    strings: {},
    locateOptions: {}
  },
  setup(e, { expose: s }) {
    const n = e, t = g(), {
      refs: { position: a },
      rest: r
    } = k(t, n, ["position"]), p = U(), o = $(), l = no({
      position: a.value,
      ...r,
      ...T(o)
    }), i = P(l);
    return q(p, l), Mo(l), s({
      locateControl: l
    }), (f, u) => y(i) ? v(f.$slots, "default", { key: 0 }) : b("", !0);
  }
});
export {
  Oo as VMap,
  Xo as VMapArcGisAeroTileLayer,
  Jo as VMapArcGisTileLayer,
  it as VMapAttributionControl,
  ct as VMapControlPosition,
  Ko as VMapDefaultIcon,
  Ze as VMapDivIcon,
  Fo as VMapDivMarker,
  Qo as VMapGoogleTileLayer,
  Bo as VMapIcon,
  Go as VMapIconMarker,
  st as VMapLayersControl,
  pt as VMapLocateControl,
  jo as VMapMapboxTileLayer,
  ve as VMapMarker,
  qo as VMapOpenTransportTileLayer,
  Ho as VMapOsmTileLayer,
  Uo as VMapPane,
  bo as VMapPinIcon,
  Do as VMapPinMarker,
  lt as VMapScaleControl,
  H as VMapTileLayer,
  rt as VMapZoomControl,
  Ve as attributionControlKey,
  Oe as controlPositionKey,
  we as divIconKey,
  Me as iconKey,
  Te as layersControlApiKey,
  xe as layersControlKey,
  Ue as locateControlKey,
  Se as mapKey,
  ae as markerApiKey,
  Re as markerKey,
  Ce as paneKey,
  Pe as provideApi,
  Ao as provideAttributionControl,
  Ro as provideControlPosition,
  _o as provideDivIcon,
  Le as provideIcon,
  So as provideLayersControl,
  Mo as provideLocateControl,
  co as provideMap,
  ho as provideMarker,
  po as providePane,
  zo as provideScaleControl,
  vo as provideTileLayer,
  Co as provideZoomControl,
  $e as scaleControlKey,
  Ae as tileLayerKey,
  se as useApi,
  tt as useAttributionControl,
  nt as useControlPosition,
  Wo as useDivIcon,
  Eo as useIcon,
  Yo as useLayersControl,
  at as useLocateControl,
  U as useMap,
  No as useMarker,
  To as usePane,
  ot as useScaleControl,
  Zo as useTileLayer,
  et as useZoomControl,
  Ie as zoomControlKey
};
